/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Email_ValidationInputs */

const en_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your email address to reset password`)
};

const fr_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer votre adresse email pour réinitialiser le mot de passe`)
};

const de_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.`)
};

const it_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il tuo indirizzo email per reimpostare la password`)
};

const ru_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите свой адрес электронной почты для сброса пароля.`)
};

const es_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese su dirección de correo electrónico para restablecer la contraseña`)
};

const zh_cn2_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的电子邮件地址以重置密码`)
};

const ja_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードをリセットするにはメールアドレスを入力してください`)
};

const hi_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड रीसेट करने के लिए कृपया अपना ईमेल पता दर्ज करें`)
};

const pt_pt2_login_error_email_validation = /** @type {(inputs: Login_Error_Email_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira seu endereço de e-mail para redefinir a senha.`)
};

/**
* | output |
* | --- |
* | "Please enter your email address to reset password" |
*
* @param {Login_Error_Email_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_email_validation = /** @type {((inputs?: Login_Error_Email_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Email_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_email_validation(inputs)
	if (locale === "de") return de_login_error_email_validation(inputs)
	if (locale === "it") return it_login_error_email_validation(inputs)
	if (locale === "ru") return ru_login_error_email_validation(inputs)
	if (locale === "es") return es_login_error_email_validation(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_email_validation(inputs)
	if (locale === "ja") return ja_login_error_email_validation(inputs)
	if (locale === "hi") return hi_login_error_email_validation(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_email_validation(inputs)
	return en_login_error_email_validation(inputs)
});